module.exports = __webpack_public_path__ + "media/images/icons/band-8393c03869e45a06ef02814bdf92c80b.svg";